export default __webpack_public_path__ + "media/components/Pages/Abitur/Images/How/2-c112c5abb1de3a18023201a0d813328e.svg";